import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {DisplayDetailConfig} from "../app-display-detail/app-display-detail.component";

// NOT_IN_USE_CURRENTLY
@Component({
    selector: 'app-display-detail-list',
    templateUrl: 'app-display-detail-list.component.html',
    standalone: false
})
export class AppDisplayDetailListComponent implements OnInit, OnChanges, OnDestroy {

  busy: boolean;  // indicator whether the component is busy
  initialized: boolean; // indicator whether the component was initialized

  @Input() dataArray: any[] = [];
  @Input() config!: DisplayDetailConfig;

  constructor() {
  }


  ngOnInit(): void {
    this.initComponent();

  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }


  /**
   * Process changes within Binding.
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

    if (changes["id"]) {
      this.refreshComponent();
    }
  }

  /**
   * Destroy component.
   */
  ngOnDestroy(): void {

  }
}
